import { render, staticRenderFns } from "./Task.vue?vue&type=template&id=ae89f9d2&scoped=true&"
import script from "./Task.vue?vue&type=script&lang=js&"
export * from "./Task.vue?vue&type=script&lang=js&"
import style0 from "./Task.vue?vue&type=style&index=0&id=ae89f9d2&lang=scss&scoped=true&"
import style1 from "./Task.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae89f9d2",
  null
  
)

export default component.exports